<script type="text/jsx">
export default {
    props: {
        value: {
            type: Boolean,
            default: null,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },

    render() {
        const data = {
            class: { checked: this.value, disabled: this.isDisabled },
            on: {
                click: () => {
                    if (this.isDisabled) {
                        return;
                    }
                    this.$emit('input', !this.value);
                    const ripple = this.$el.querySelector('.ripple');
                    ripple.classList.add('animate');
                    setTimeout(() => {
                        this.$nextTick(() => {
                            ripple.classList.remove('animate');
                        });
                    }, 400);
                },
            },
        };
        return <div class="ui-toggle" {...data}>
            <div class="toggle">
                <div class="ripple" />
            </div>
        </div>;
    },
};
</script>

<style lang="scss">
    @import "common/scss/variables";
    @import "common/scss/palette";
    @import '@/styles/colors/variables';
    @import "common/scss/variables/v2/shadows";

    $toggle-size: 14px;
    $track-width: 35px;
    $track-height: 20px;
    $toggle-padding: ($track-height - $toggle-size) * 0.5;

    .ui-toggle {
        @apply bg-mouse relative cursor-pointer;
        height: $track-height;
        width: $track-width;
        margin: 0;
        border-radius: $track-height * 0.5;

        &.disabled {
            @apply cursor-not-allowed;
        }

        .toggle {
            transition: 0.3s ease all;
            top: $toggle-padding;
            left: $toggle-padding;
            position: relative;
            &:after {
                @apply bg-white border-white rounded-full absolute;
                content: "";
                display: block;
                position: absolute;
                width: $toggle-size;
                height: $toggle-size;
                box-shadow: $shadow-level-control;
                left: 0;
                top: 0;
            }
        }

        &.checked {
            @apply bg-leaf;

            .toggle {
                left: $track-width - $toggle-size - $toggle-padding !important;
            }
        }

        .ripple {
            @apply relative rounded-full bg-leaf;
            width: $toggle-size;
            height: $toggle-size;
            transform: inherit;
            pointer-events: none;
            opacity: 0;
            &.animate {
                animation: toggle-scale-circle 0.6s;
            }
        }

        @keyframes toggle-scale-circle {
            0% {
                transform: inherit;
                transform: scale(1);
                opacity: 0.2;
            }
            30% {
                transform: inherit;
                transform: scale(2.5);
                opacity: 0.4;
            }
            100% {
                transform: inherit;
                transform: scale(.2);
                opacity: 0;
            }
        }
    }
</style>
